// assets
import { IconDashboard, IconDeviceAnalytics, IconFileInvoice, IconArticle, IconLifebuoy } from '@tabler/icons-react';
import { GpsFixed } from '@mui/icons-material';
import AccountTree from '@mui/icons-material/AccountTree';
import FolderIcon from '@mui/icons-material/Folder';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import Settings from '@mui/icons-material/Settings';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import ContentCutOutlinedIcon from '@mui/icons-material/ContentCutOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
// types
import { NavItemType } from 'types';
const icons = {
  IconDashboard: IconDashboard,
  IconDeviceAnalytics: IconDeviceAnalytics,
  IconFileInvoice: IconFileInvoice,
  IconArticle: IconArticle,
  IconLifebuoy: IconLifebuoy
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //



let is_admin = true;//session?.session?.is_admin ?? false; 


const dashboardChildren = [
  {
    id: 'default',
    title: 'default',
    type: 'item',
    url: '/dashboard/default',
    icon: DashboardCustomizeOutlinedIcon,
    breadcrumbs: false
  },
  // {
  //   id: 'production',
  //   title: 'production',
  //   type: 'item',
  //   url: '/production',
  //   icon: ContentCutOutlinedIcon,
  //   breadcrumbs: false
  // },
  {
    id: 'projects',
    title: 'projects',
    type: 'item',
    url: '/projects',
    icon: AccountTreeOutlinedIcon,
    breadcrumbs: false
  },
  //   {
  //   id: 'measures',
  //   title: 'measures',
  //   type: 'item',
  //   url: '/measures',
  //   icon: MonitorHeartOutlinedIcon,
  //   breadcrumbs: false
  // },
  //  {
  //   id: 'analyzed',
  //   title: 'analyzed',
  //   type: 'item',
  //   url: '/analyzed',
  //   icon: TroubleshootIcon,
  //   breadcrumbs: false
  // },
  // {
  //   id: 'messprojects',
  //   title: 'messprojects',
  //   type: 'item',
  //   url: '/messprojects',
  //   icon: FolderIcon,
  //   breadcrumbs: false
  // },
  {
    id: 'system',
    title: 'system',
    type: 'item',
    url: '/system',
    icon: SettingsOutlinedIcon,
    breadcrumbs: false
  }
];



if (is_admin) {
  dashboardChildren.push({
    id: 'test',
    title: 'test',
    type: 'item',
    url: '/test',
    icon: SettingsSuggestOutlinedIcon,
    breadcrumbs: false
  });
}

const dashboard: NavItemType = {
  id: 'dashboard',
  //title: 'dashboard',
  title: '',
  icon: icons.IconDashboard,
  type: 'group',
  children: dashboardChildren
};

export default dashboard;
